<template>
  <pop-modal :visible="visible" :isDrag="true" title="发票申领" @cancel="handelCancel" width="700px" :height="95">
    <div class="wrap">
      <div class="invoiceInfo pd">
        <div>
          <div class="circle"></div>
          <span>申领发票信息</span>
        </div>
        <div>
          <div class="flex jc-between indent pd">
            <div>
              <span class="mr-1">发票类型</span
              ><select v-model="invoiceClass">
                <option value="0">专用发票</option>
                <option value="1">普通发票</option>
                <option value="3">电子普通发票</option>
              </select>
            </div>
            <div><span class="mr-1">申领数量(本/卷)</span><input type="number" v-model="applyNum" /></div>
          </div>
          <div class="flex jc-between indent pd">
            <div class="flex ai-center">
              <span class="mr-1">发票种类</span>
              <span style="width: 195px; height: 35px; line-height: 35px; display: inline-block">{{
                invoiceClass
              }}</span>
            </div>
            <div class="flex ai-center">
              <span class="mr-1">本次限量(本/卷)</span
              ><span style="width: 195px; height: 35px; line-height: 35px; display: inline-block">{{
                expressAddrInfo[invoiceClass]
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="personInfo pd">
        <div>
          <div class="circle"></div>
          <span>申领人信息</span>
        </div>
        <div>
          <div class="flex jc-between indent pd">
            <div>
              <span class="mr-1">证件类型</span>
              <select>
                <option value="0">身份证</option>
              </select>
            </div>
            <div><span class="mr-1">证件号码</span><input type="text" value="370883198603******" /></div>
          </div>
          <div class="flex jc-between indent pd">
            <span class="mr-1">经办人 </span><input type="text" style="flex: 1" :value="expressAddrInfo.drawer" />
          </div>
        </div>
      </div>
      <div class="applyMethods pd">
        <div>
          <div class="circle"></div>
          <span>领票方式</span>
        </div>
        <div>
          <div class="flex jc-between indent pd">
            <div>
              <a-radio-group v-model="isExpress" @change="applyMethChange">
                <a-radio :value="1"> 自行领取 </a-radio>
                <a-radio :value="2"> 快速配送 </a-radio>
              </a-radio-group>
              <span class="color-blue">管理收件地址</span>
            </div>
            <div class="color-blue">法律声明</div>
          </div>
        </div>
        <span class="color-blue">*说明：发票配送费用请参看省市税务局门户网站</span>
      </div>
      <div class="applyExplain flex jc-between pd">
        <div class="mr-1">申领说明</div>
        <textarea name="" id="" rows="5"></textarea>
      </div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'center',
          zIndex: 1,
        }"
      >
        <a-button style="margin: 0 20px" type="primary" @click="applySubmit()" ghost>申领</a-button>
        <a-button style="margin: 0 20px" type="primary" @click="handelCancel()" ghost>取消</a-button>
      </div>
    </div>
  </pop-modal>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam } from '@/utils/util'
import { mapActions } from 'vuex'

export default {
  name: 'OnlineApply',
  data() {
    return {
      visible: false,
      expressAddrInfo: {
        drawer: '',
        address: '',
        phone: '',
        '0': '',
        '1': '',
        '3': '',
      },
      invoiceClass: '0',
      isExpress: 1,
      applyNum: 0,
    }
  },
  methods: {
    show() {
      this.visible = true
      this.getExpressAddrInfo()
    },
    handelCancel() {
      this.visible = false
    },
    // 获取快递配送相关信息
    async getExpressAddrInfo() {
      const params = parseParam()
      const res = await this.$http.post(`${Urls.getExpressAddrInfo}&${params}`)
      if (res.statusCode === '200') {
        for (const key in res) {
          if (Object.hasOwnProperty.call(res, key)) {
            const element = res[key]
            this.expressAddrInfo[key] = element
          }
        }
      } else {
        this.$message.warning(res.msg)
      }
    },
    applyMethChange(v) {},
    async applySubmit() {
      const payInvoice = await this.getTasksBySeq(3)
      if (!payInvoice) {
        this.$error({
          title: '警告',
          content: '购买发票业务不存在或已结束!',
        })
        return
      }
      if (this.applyNum > this.expressAddrInfo[this.invoiceClass]) {
        this.$error({
          title: '警告',
          content: '本次购买超过限量!',
        })
        return
      }
      if (this.applyNum <= 0) {
        this.$error({
          title: '警告',
          content: '请输入正确的发票数!',
        })
        return
      }
      const params = parseParam({
        moduleId: payInvoice.id,
        taxClass: this.invoiceClass,
        taxBillBuyNum: this.applyNum,
      })
      const res = this.$http.post(`${Urls.onLineApplyInvoice}&${params}`)
      if (res.statusCode === '200') {
        this.$info({
          title: '提示',
          content: res.msg,
        })
      }
    },
    cancelForm() {},
    ...mapActions('practice', ['getTasksBySeq']),
  },
}
</script>

<style lang="less" scoped>
.circle {
  width: 10px;
  height: 10px;
  border: 1px solid #5eb9ff;
  border-radius: 100px;
  background-color: #5eb9ff;
  margin-right: 10px;
  display: inline-block;
}
.wrap {
  padding: 10px;
  color: #000;
}
.pd {
  padding: 5px;
}
input[type='text'],
input[type='number'],
select,
textarea {
  outline: none;
  border: 1px solid #91cefd;
}
input[type='text'],
input[type='number'],
select {
  height: 35px;
  width: 195px;
}
textarea {
  width: 100%;
  flex: 1;
}
.indent {
  text-indent: 32px;
}
.applyExplain {
  margin-top: 30px;
}
.color-blue {
  color: #2389ee;
}
</style>
